import React, { useState, useEffect } from "react";
import Header from "../../Components/Header";
import ProfileForm from "./ProfileForm";
import "./Profile.css";

export const Profile = (props) => {
  // console.log(props.data);
  const [titles, setTitles] = useState(props.data);

  const getTitleCards = (titlesArray) => {
    // console.log(titlesArray, " from profile form"); //has empty string as last item of array
    setTitles(titlesArray);
    // console.log(titles); //empty array
    props.handleCallback(titles);
  };

  useEffect(() => {
    getTitleCards(titles);
    // console.log("useEffect");
  }, [titles]);

  return (
    <div>
      <Header title="Profile" />
      <ProfileForm
        {...props}
      />
    </div>
  );
};

// export default Profile;
